import { getHostname } from './getHostname';

const DESIGN_SYSTEM_SERVER_URLS = {
  production: 'https://design-system-bff.zapier.com',
  staging: 'https://design-system-bff.zapier-staging.com',
  localhost: 'http://localhost:8000',
};

export const getServerUrl = (): string => {
  const hostname = getHostname();

  if (hostname.endsWith('zapier.com')) {
    return DESIGN_SYSTEM_SERVER_URLS.production;
  } else if (hostname.endsWith('zapier-staging.com')) {
    return DESIGN_SYSTEM_SERVER_URLS.staging;
  } else if (hostname === 'localhost') {
    return DESIGN_SYSTEM_SERVER_URLS.localhost;
  }

  return DESIGN_SYSTEM_SERVER_URLS.staging;
};
